import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import baseurl from "./Baseurl";
import secureLocalStorage from "react-secure-storage";
const Manubar = () => {
  let Navigate = useNavigate();
  let [showprofile, setshowprofile] = useState([]);
  let [show_f_cartlist, setshow_f_cartlist] = useState([]);
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const items = { user_id: _id };
        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_user_profile`,
          items,
          {
            headers: {
              token: token,
            },
          }
        );

        if (res.data.result) {
          setshowprofile(res.data.data);
        }
      } catch (error) {
        console.log("Error fetching user profile", error);
      }
    };

    fetchUserProfile();
  }, [_id, token]);

  // singout Handel
  let singout = () => {
    try {
      let item = {
        _id: _id,
      };
      axios
        .post(`${baseurl[0].apiurl}logout`, item)
        .then((res) => {
          //console.log(res)
          if (res.data.result) {
            localStorage.removeItem("ssstoken");
            secureLocalStorage.removeItem("n_id");
            secureLocalStorage.removeItem("n_token");
            secureLocalStorage.removeItem("n_mobile_no");
            secureLocalStorage.removeItem("n_otp");
            Navigate(`/`);
          }
        })
        .catch((error) => {
          //  console.log(error)
        });
    } catch (error) {}
  };

  // get all favourite list
useEffect(() => {
  const fetchFavouriteList = async () => {
    try {
      const items = { user_id: _id };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/get_favourite_product_list`,
        items,
        {
          headers: { token }
        }
      );

      if (res.data?.result) {
        setshow_f_cartlist(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching favourite list:", error);
    }
  };

  if (_id && token) fetchFavouriteList();
}, [_id, token]);


  return (
    <>
      <div className="modal-header offcanvas-header">
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          style={{
            fontSize: "25px",
            margin: "10px",
            position: "relative",
            right: "-240px",
          }}
        />
      </div>
      <div className="bg-white">
        <ul className="quick-links justify-content-center">
          {/* quick-link-item */}
          <li
            className="quick-link-item d-inline-flex"
            style={{ marginRight: "100px" }}
          >
            <span className="quick-link-icon flex-shrink-0">
              <a href="#" className="quick-link">
                <i
                  className="las la-user-circle"
                  style={{ marginTop: "10px" }}
                />
              </a>
            </span>
            <span className="flex-grow-1">
              {_id ? (
                <div>
                  {" "}
                  <Link to="/myaccount">{showprofile?.full_name}</Link> <br />
                  <Link onClick={singout}>Sign out</Link>{" "}
                </div>
              ) : (
                <div>
                  {" "}
                  <a
                    style={{ marginTop: "15px" }}
                    href="/login"
                    class="my-account"
                  >
                    Register
                  </a>
                </div>
              )}
            </span>
          </li>
          <li className="quick-link-item d-inline-flex">
            <a href="/Favratewishlist" className="quick-link">
              <span className="quick-link-icon flex-shrink-0">
                <i className="lar la-heart" />
                <span className="badge rounded-pill bg-success">
                  {token ? show_f_cartlist.length : "0"}
                </span>
              </span>
            </a>
          </li>
          {/* quick-link-item end */}
        </ul>
      </div>
      <a href="/Shearch_mobile">
        <form action="#" className="offcanvas-form">
          <input
            type="text"
            className="form-control"
            placeholder="Enter your search key ,,, "
          />
          <button className="btn-search btn-success" type="submit">
            <i className="las la-search" />
          </button>
        </form>
      </a>
      {/* offcanvas-mobile-menu start */}
      <nav id="" className="offcanvas-menu">
        <ul>
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            {token ? (
              <a href="/myaccount">Myaccount</a>
            ) : (
              <a href="/login">Myaccount</a>
            )}
          </li>
          <li>{/* <a href="/mobile_category">Shop by category</a> */}</li>
          <li>
            {token ? (
              <a href="/myaccount">My order</a>
            ) : (
              <a href="/login">My order</a>
            )}
          </li>
          <li>
            {token ? <a href="/offer">Offers</a> : <a href="/login">Offers</a>}
          </li>
          {/* <li>
                        <a href="contact.html">Support</a>
                    </li>
                    <li>
                        <a href="contact.html">Settings</a>
                    </li> */}
        </ul>
        <div className="offcanvas-social">
          <ul>
            <li>
              <a href="#">
                <i className="ion-social-facebook" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="ion-social-twitter" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="ion-social-instagram" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="ion-social-google" />
              </a>
            </li>
            <li>
              <a href="#">
                <i className="ion-social-instagram" />
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Manubar;
